import { forwardRef, useRef, useState } from 'react';
// import { setTimeout } from 'timers';
import axios from 'axios';
import FileIcon from '../../assets/file.svg';
import enter from '../../assets/sendNew.svg';
import SmileIcon from '../../assets/smile.svg';
import { containerState } from '../../constant';
import { getDownloadPreSignedUrl, getUploadPreSignedUrl } from '../../utils/api.js';
import EmojiList from './EmojiList';
import './index.scss';
import {
  ControlsWrapper,
  EditorContainer,
  IconContainer,
  IconWrapper,
  InputContainer,
  InputWrapper,
  ItemWrapper,
  LeftWrapper,
  RightWrapper,
  Textarea1,
} from './styled';
// 定义图片和视频的后缀名数组
const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
const videoExtensions = ['.mp4', '.mov', '.avi'];

const Editor = forwardRef((props, ref) => {
  const [text, setText] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const textareaRef = useRef(null);
  // 从props中解构回调函数
  const {
    sendMessage,
    inputDisable,
    setUploadProgress,
    setUploadCancelToken,
    chatConfig,
    updateMessageById,
    container,
    isHistory,
    handleClickToAgent,
    agentDisabled,
    IMWebClient,
    setFileSizeErrorModal,
  } = props;

  const handleKeyPress = async (event) => {
    if (inputDisable) {
      return;
    }
    if (event.key === 'Enter' && !event.shiftKey) {
      // 阻止默认的换行行为
      event.preventDefault();
      // 发送消息
      await sendMessage(text);
      setText('');
    }
  };

  const handleEnter = async (event) => {
    if (inputDisable) {
      return;
    }
    event.preventDefault();
    await sendMessage(text);
    setText('');
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0]; // 获取上传的文件
    if (file.size > 200 * 1024 * 1024) {
      setFileSizeErrorModal(true);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    // 创建一个新的取消令牌
    const source = axios.CancelToken.source();
    setUploadCancelToken(source);
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const date = `${year}/${month}/${day}`;
    let fileName = new Date().getTime() + '_' + file.name;

    let cancel = false;
    // 预签名
    await getUploadPreSignedUrl(fileName, file.type, chatConfig.companyId, date).then(async (res) => {
      let contentType = '';
      let contentType1 = '';
      if (isImage(fileName)) {
        contentType = 'image';
        contentType1 = 'image/jpeg';
      } else if (isVideo(fileName)) {
        contentType = 'video';
        contentType1 = 'video/mp4';
      } else {
        contentType = 'link';
        contentType1 = 'application/octet-stream';
      }

      // 发一个上传中的消息
      let messageId = await sendMessage(res.data, contentType, fileName, false, 0, 'active');

      // 使用干净的 axios 实例，避免默认/拦截器添加多余请求头
      const ax = axios.create();
      // 移除常见会触发预检或干扰 S3 的默认头
      if (ax.defaults && ax.defaults.headers && ax.defaults.headers.common) {
        delete ax.defaults.headers.common['X-Requested-With'];
        delete ax.defaults.headers.common['Content-Type'];
      }
      let headers = {
        'Content-Type': contentType1,
      };
      if (contentType == 'video') {
        headers['x-amz-tagging'] = 'FileType=large';
      }
      // 创建上传任务
      const upload = ax
        .put(res.data, file, {
          headers: headers,
          onUploadProgress: (progressEvent) => {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let progress = {
              fileName: fileName,
              progress: percentCompleted,
            };
            setUploadProgress((prevProgress) => {
              return [...prevProgress.filter((upload) => upload.fileName !== fileName), progress];
            });
          },
          cancelToken: source.token,
        })
        .catch(async () => {
          updateMessageById(messageId, res.data, 'exception');
          cancel = true;
        })
        .finally(async () => {
          setUploadCancelToken(null);
          if (!cancel) {
            // 获取预签名url，显示附件
            await getDownloadPreSignedUrl(fileName, file.type, chatConfig.companyId, date).then(async (res) => {
              if (res.code === 200) {
                updateMessageById(messageId);
                await sendMessage(res.data, contentType, fileName, false);
              }
            });
          }
        });
    });
  };

  const isImage = (fileName) => {
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(extension);
  };

  // 判断文件后缀是否为视频
  const isVideo = (fileName) => {
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return videoExtensions.includes(extension);
  };
  const changeEmoji = (event) => {
    setShowEmojiPicker(!showEmojiPicker);
  };
  const handleClickEmoji = (e) => {
    const newValue = text + e;
    // 确保字符数不超过1000
    if (newValue.length <= 1000) {
      setText(newValue);
    }
    setShowEmojiPicker(!showEmojiPicker);
    // 获取输入框
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };
  const handleClickUpload = () => {
    // 步骤1：创建input元素
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '*/*'; // 支持所有文件类型
    // 将input元素添加到DOM中
    document.body.appendChild(fileInput);
    // 步骤2：触发选择文件事件
    fileInput.click();
    // 步骤3：选择文件后删除input元素
    fileInput.addEventListener('change', handleFileUpload);
    // 从DOM中删除input元素
    fileInput.remove();
  };
  return (
    <EditorContainer>
      <ControlsWrapper>
        {showEmojiPicker && <EmojiList handleClickEmoji={handleClickEmoji} />}
        <LeftWrapper>
          <IconWrapper>
            <img onClick={changeEmoji} src={SmileIcon} alt="" />
          </IconWrapper>
          <IconWrapper>
            <img onClick={handleClickUpload} src={FileIcon} alt="" />
          </IconWrapper>
        </LeftWrapper>
        <RightWrapper>
          {!isHistory &&
          container === containerState.CHAT_WIDGET &&
          (chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3') &&
          chatConfig.showToAgentFlag === '1' ? (
            agentDisabled ? (
              <ItemWrapper $themecolor={chatConfig.chatThemeColor} onClick={handleClickToAgent}>
                {AgentIcon(chatConfig.chatThemeColor, 20, 20)}
                {chatConfig.showToAgentName != false ? <span>{chatConfig.menuToAgentTxt.split(',')[0]}</span> : ''}
              </ItemWrapper>
            ) : (
              <ItemWrapper $themecolor={'#999'}>
                {AgentIcon('#999', 20, 20)}
                {chatConfig.showToAgentName != false ? <span>{chatConfig.menuToAgentTxt.split(',')[0]}</span> : ''}
              </ItemWrapper>
            )
          ) : (
            ''
          )}
        </RightWrapper>
      </ControlsWrapper>

      <InputWrapper>
        <InputContainer>
          <Textarea1
            ref={textareaRef}
            value={text}
            onChange={(e) => {
              let value = e.target.value;
              // 确保字符数不超过1000
              if (value.length > 1000) {
                return;
              } else {
                setText(value);
                IMWebClient.userInput();
              }
            }}
            maxLength={1000}
            onKeyPress={handleKeyPress}
          />
        </InputContainer>
        <IconContainer>
          {inputDisable ? (
            <div className="loader" style={{ width: 20, height: 20 }}></div>
          ) : (
            <img onClick={handleEnter} src={enter} alt="" />
          )}
        </IconContainer>
      </InputWrapper>
    </EditorContainer>
  );
});
const AgentIcon = (color, width = 18, height = 18) => (
  <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00034 3.14258C7.57834 3.14258 8.85748 4.42172 8.85748 5.99972H8.00034C8.00033 5.60708 7.88475 5.22313 7.66801 4.89573C7.45127 4.56833 7.14295 4.31197 6.7815 4.15861C6.42004 4.00526 6.02144 3.96169 5.6354 4.03333C5.24935 4.10498 4.89293 4.28867 4.61057 4.56151C4.32821 4.83435 4.13241 5.18427 4.04758 5.56764C3.96275 5.951 3.99263 6.35086 4.13351 6.71736C4.27439 7.08385 4.52003 7.40078 4.83981 7.62861C5.15959 7.85645 5.53936 7.98512 5.93177 7.99858L6.00034 7.99972C7.81234 7.99972 9.3432 9.20458 9.83463 10.8569H8.92891C8.47177 9.68629 7.33291 8.85686 6.00034 8.85686C4.66777 8.85686 3.52891 9.68629 3.07177 10.8569H2.16605C2.33138 10.3045 2.61383 9.79432 2.99418 9.36103C3.37452 8.92773 3.84381 8.58153 4.37005 8.34601C3.99111 8.08324 3.68153 7.7325 3.46785 7.32386C3.25418 6.91522 3.14278 6.46086 3.1432 5.99972C3.1432 4.42172 4.42234 3.14258 6.00034 3.14258ZM6.00034 1.14258C8.11063 1.14258 9.8392 2.77686 9.98977 4.84858C10.2324 5.02687 10.4124 5.27725 10.5043 5.56397C10.5961 5.85069 10.595 6.1591 10.5011 6.44516C10.4073 6.73122 10.2254 6.98031 9.98155 7.15686C9.73768 7.33342 9.44427 7.42842 9.1432 7.42829L7.28605 7.42858C7.1961 7.54851 7.0707 7.6371 6.9276 7.6818C6.78451 7.7265 6.63097 7.72504 6.48875 7.67764C6.34653 7.63023 6.22282 7.53928 6.13517 7.41766C6.04751 7.29604 6.00034 7.14992 6.00034 7.00001C6.00034 6.85009 6.04751 6.70397 6.13517 6.58236C6.22282 6.46074 6.34653 6.36978 6.48875 6.32238C6.63097 6.27497 6.78451 6.27351 6.9276 6.31821C7.0707 6.36291 7.1961 6.4515 7.28605 6.57144L9.1432 6.57115C9.29475 6.57115 9.44009 6.51095 9.54726 6.40378C9.65442 6.29662 9.71463 6.15127 9.71463 5.99972C9.71463 5.84817 9.65442 5.70282 9.54726 5.59566C9.44009 5.4885 9.29475 5.42829 9.1432 5.42829V5.14258C9.1432 3.40686 7.73605 1.99972 6.00034 1.99972C4.26463 1.99972 2.85748 3.40686 2.85748 5.14258V5.42829C2.70593 5.42829 2.56059 5.4885 2.45342 5.59566C2.34626 5.70282 2.28605 5.84817 2.28605 5.99972C2.28605 6.15127 2.34626 6.29662 2.45342 6.40378C2.56059 6.51095 2.70593 6.57115 2.85748 6.57115V7.42829C2.55649 7.42833 2.26317 7.3333 2.01938 7.15676C1.7756 6.98022 1.59381 6.73119 1.49995 6.4452C1.40608 6.15921 1.40495 5.85089 1.49671 5.56422C1.58847 5.27755 1.76843 5.02719 2.01091 4.84886C2.16148 2.77686 3.89005 1.14258 6.00034 1.14258Z"
      fill={color}
    />
  </svg>
);
export default Editor;
